import { ROLES } from '../models/roles';
import { FORMS, FORM_STATUS } from '../models/forms';
import { SUBMISSIONS, SUBMISSION_STATUS } from '../models/submissions';
import { USERS } from '../models/users';

function delay(ms = 400) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** KPIs + actividad reciente para el dashboard del Operativo. */
export async function getDataEntryStats(userId) {
  await delay();

  const mySubmissions = SUBMISSIONS.filter((s) => s.submittedBy === userId).sort(
    (a, b) => new Date(b.submittedAt) - new Date(a.submittedAt)
  );
  const assignedForms = FORMS.filter(
    (f) => f.assignedRoles.includes(ROLES.DATA_ENTRY) && f.status === FORM_STATUS.ACTIVE
  );

  return {
    assignedForms: assignedForms.length,
    totalSubmissions: mySubmissions.length,
    pending: mySubmissions.filter((s) => s.status === SUBMISSION_STATUS.PENDING).length,
    approved: mySubmissions.filter((s) => s.status === SUBMISSION_STATUS.APPROVED).length,
    recent: mySubmissions.slice(0, 5),
  };
}

/** KPIs + actividad reciente para el dashboard del Analista. */
export async function getAnalystStats() {
  await delay();

  const totalSubmissions = FORMS.reduce((acc, f) => acc + f.totalSubmissions, 0);
  const approved = FORMS.reduce((acc, f) => acc + f.approvedCount, 0);
  const activeForms = FORMS.filter((f) => f.status === FORM_STATUS.ACTIVE).length;
  const activeAnalysts = USERS.filter((u) => u.role === ROLES.ANALYST && u.active).length;
  const completionRate = totalSubmissions ? Math.round((approved / totalSubmissions) * 100) : 0;

  const recent = [...SUBMISSIONS]
    .sort((a, b) => new Date(b.submittedAt) - new Date(a.submittedAt))
    .slice(0, 6);

  return { totalSubmissions, activeForms, completionRate, activeAnalysts, recent };
}

/** KPIs generales para el dashboard del Administrador. */
export async function getAdminStats() {
  await delay();

  return {
    totalUsers: USERS.length,
    activeUsers: USERS.filter((u) => u.active).length,
    totalForms: FORMS.length,
    activeForms: FORMS.filter((f) => f.status === FORM_STATUS.ACTIVE).length,
    totalSubmissions: FORMS.reduce((acc, f) => acc + f.totalSubmissions, 0),
  };
}
